import { history } from '@/routes'
import { always, cond, test } from 'ramda'

export type IWebPlatformLevel = 'Global' | 'Admin' | 'Regular'

/**
 * 取的目前頁面的系統層級
 * @returns 'Global' | 'Admin' | 'Regular'
 */
const useWebPlatformLevel = (): IWebPlatformLevel => {
  const pathName = history.location.pathname

  const result = cond<any, IWebPlatformLevel>([
    [test(/\/(?=.*global)(.)*/), always('Global')],
    [test(/\/(?=.*admin)(.)*/), always('Admin')],
    [test(/\/(?!.*admin|.*global)(.*)/), always('Regular')],
  ])(pathName)

  return result
}

export default useWebPlatformLevel
